import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import EditIcon from '../../../assets/dateinachweise.png';
import EditIconNoDocuments from '../../../assets/no-dateinachweise.png';
import Api from "../../../Api/api";

const DateinachweiseBadge = ({ portal, companyID }) => {
    const [hasDocumentsToShow, setHasDocumentsToShow] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!companyID || !portal) return;

        const fetchDocuments = async () => {
            setLoading(true);

            try {
                const res = await Api().get(`/sp_getDataDocuments/${portal}/${companyID}`);
                const sections = [res.data.firstSection, res.data.secondSection, res.data.thirdSection];
                const uploadedDocs = sections.flat().filter(doc => doc?.Upload_Datum !== null);

                if (uploadedDocs.length !== 0) {
                    setHasDocumentsToShow(true);
                } else {
                    setHasDocumentsToShow(false);
                }
            } catch (e) {
                console.error('Error fetching documents:', e);
                setHasDocumentsToShow(false);
            } finally {
                setLoading(false);
            }
        };

        fetchDocuments();
    }, [portal, companyID]);

    if (loading) {
        return (
            <div className='flex justify-center items-start content-center flex-wrap'>
                <div className='py-2 px-5 flex items-center'>
                    <ClipLoader size={16} color={'#6e6e6e'} />
                </div>
            </div>
        );
    }

    return (
        <div className='flex justify-center items-start content-center flex-wrap'>
            <Link
                className='py-2 mt-2 px-5 flex items-center text-2xl'
                target="_blank"
                to={`/dateinachweise/${portal}/${companyID}`}
                title={hasDocumentsToShow ? "Dateinachweise" : "keine Dateinachweise vorhanden"}
            >
                <img
                    src={hasDocumentsToShow ? EditIcon : EditIconNoDocuments}
                    alt="FP Edit"
                    className='w-6 h-6'
                />
                {!hasDocumentsToShow ? (
                    <span className={`text-sm ms-2 border border-1 border-whiteDarker p-1 rounded shadow`}>
                        keine Dateinachweise vorhanden
                    </span>
                ) : (
                    <span className={`text-sm ms-2 border border-1 border-whiteDarker p-1 rounded shadow`}>
                        Dateinachweise vorhanden
                    </span>
                )}
            </Link>
        </div>
    );
};

export default DateinachweiseBadge;
